export default "__VITE_ASSET__WPsYHIMg__"